import WorthyApi from 'lib/api/worthyApi'

export const ITEMS_COUNT = Symbol('ITEMS_COUNT')

export function getItemsCount(userId) {
	const request = WorthyApi.getUserCurrentItemsCount(userId)

    return {
        type:       ITEMS_COUNT,
        payload:    request
    }
}
